import classNames from "classnames";
import React, { RefObject, useCallback, useRef, useState } from "react";
import ContentEditable, { ContentEditableEvent } from "react-contenteditable";

import Multiply from "assets/iconsv2/multiply-16.svg";
import Upload from "assets/iconsv2/upload-16.svg";
import Brush from "assets/iconsv2/brush-16.svg";

import styles from "./FloatingNotesExample.module.css";

const GRADIENTS = [
  "linear-gradient(135deg, rgba(153, 119, 251, 0.7) 0%, rgba(221, 50, 49, 0.7) 100%)",
  "linear-gradient(135deg, rgba(86, 211, 129, 0.7) 0%, rgba(21, 17, 194, 0.7) 100%)",
  "linear-gradient(135deg, rgba(254, 228, 91, 0.7) 0%, rgba(206, 53, 53, 0.7) 100%)",
  "linear-gradient(135deg, rgba(255, 239, 89, 0.7) 0%, rgba(40, 185, 89, 0.7) 100%)",
  "rgb(29,30,32)",
];

const isNotEmpty = (str: string) => str.length !== 0;

function wordCount(content: string) {
  return content.replace(/\n/g, " ").replace(/\s+/g, " ").split(" ").filter(isNotEmpty).length;
}
function characterCount(content: string) {
  return content.replace(/\n/g, " ").replace(/\s+/g, "").length;
}

const initialText = `Knight Rider. A shadowy flight into the dangerous world of a man who does not exist.

"And to our future. No matter who it may take us up against or where."`;

const FloatingNotesExample: React.FC = () => {
  const contentEditableRef = useRef<HTMLElement>() as RefObject<HTMLElement>;
  const [gradientIndex, setGradientIndex] = useState(0);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [content, setContent] = useState(initialText);
  const textContent = contentEditableRef.current?.innerText || "";

  const handleChange = useCallback((event: ContentEditableEvent) => {
    setContent(event.target.value);
  }, []);

  const share = useCallback(async () => {
    try {
      await navigator.share({
        text: content,
      });
    } catch (err) {
      navigator.clipboard.writeText(content);
      setTooltipVisible(true);
      setTimeout(() => setTooltipVisible(false), 2000);
    }
  }, [content]);

  return (
    <div
      className={styles.wrapper}
      style={
        {
          "--gradient": GRADIENTS[gradientIndex],
        } as React.CSSProperties
      }
    >
      <div className={styles.topbar}>
        <i className={styles.closeButton}>
          <Multiply className="icon" />
        </i>
        <span className={styles.spacer}></span>
        <i className={styles.shareButton} onClick={share}>
          <Upload className="icon" />
        </i>

        <div className={classNames(styles.tooltip, { [styles.visible]: tooltipVisible })}>
          Copied Note to clipboard!
        </div>
      </div>
      <ContentEditable
        className={styles.content}
        innerRef={contentEditableRef}
        html={content}
        onChange={handleChange}
      />
      <div className={styles.footer}>
        <a className={styles.colorPicker} onClick={() => setGradientIndex((i) => (i + 1) % GRADIENTS.length)}>
          <Brush className="icon" />
        </a>
        <span className={styles.spacer}></span>
        <span className={styles.words}>
          {wordCount(textContent)} words · {characterCount(textContent)} characters
        </span>
      </div>
    </div>
  );
};

export default FloatingNotesExample;
